import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SummaryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 226px;
  justify-content: space-between;

  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLORS.tableBg};
  padding: 36px;

  @media ${media.desktop} {
    min-height: 0;
    padding: 24px;
  }
`;

export const SummaryItemTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
`;

export const SummaryItemContentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media ${media.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
  }
`;

export const SummaryItemContent = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: ${({ isDarkmode }) =>
    isDarkmode
      ? '0px 0px 23px -5px rgba(255, 255, 255, 0.15)'
      : '0px 0px 23px -5px rgba(0, 0, 0, 0.075)'};
`;

export const SummaryDesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
`;

export const SummaryItemDes = styled.div`
  color: ${({ theme }) => theme.COLORS.greenText};
  font-size: 16px;
  line-height: 1.25;
  font-weight: 400;
`;

export const SummaryItemSubDes = styled.div`
  position: absolute;
  color: ${({ theme }) => theme.COLORS.itemContent};
  font-size: 14px;
  font-weight: 400;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;

export const SummaryItemName = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;

  font-size: 32px;
  font-weight: 600;
  height: 32px;

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const SummaryItemButton = styled.button`
  border: 1px solid #ff5c17;
  border-radius: 4px;
  width: 100%;
  height: 54px;
  color: #ff5c17;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif !important;

  @media ${media.desktop} {
    height: 42px;
    font-size: 14px;
  }
`;

export const tetherImg = styled.img`
  width: 32px;
  height: 32px;
  position: relative;

  @media ${media.mobile} {
    width: 24px;
    height: 24px;
  }
`;

export const ClaimedRewardButton = styled.button`
  margin-top: 6px;
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  background: #9e9e9e;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
`;

export const RewardButton = styled.button`
  margin-top: 6px;
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  background: #0dcb81;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;

  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ExternalTabButton = styled.button<{ isDarkmode: boolean }>`
  padding: 8px 14px;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ isDarkmode }) => (isDarkmode ? '#3A3B3F' : '#C2D3CC')};
  border-top: none;
  border-radius: 0px 0px 10px 10px;
  background: ${({ isDarkmode }) => (isDarkmode ? '#232425' : '#D3E6DF')};
  color: ${({ theme }) => theme.COLORS.greenText};
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 0;
  clip-path: polygon(0 0, 100% 0, calc(100% - 12px) 100%, 12px 100%);

  span {
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const DisabledRewardButton = styled.button`
  margin-top: 6px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ff5c17;
  background: transparent;
  color: #ff5c17;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Pretendard';
  cursor: pointer;

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const DescriptionContainer = styled.div<{ isDarkmode: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 24px;
  background-color: ${({ isDarkmode }) =>
    isDarkmode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;

  @media ${media.mobile} {
    margin-top: 16px;
    padding: 16px 20px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const DescriptionContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  opacity: 0.8;
  flex: 1;

  @media ${media.mobile} {
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;
